<div class="box">
    <p class="title is-level-5 has-text-centered">Commandez dès maintenant</p>
    <div class="columns is-tablet is-multiline has-text-tertiary">
        @for (choice of choicesByType[type]; track choice) {
            @if (!configuration[choice].isHidden) {
                <div class="column is-3-tablet has-text-centered">
                    <span class="icon is-large">
                        <i [id]="'reinsurance-' + choice | lowercase" [ngClass]="configuration[choice].icon"></i>
                    </span>
                    <p class="text is-level-2 is-marginless">
                        <span class="has-text-weight-semibold">{{ translations[choice].label }}</span>
                    </p>
                    <p class="text is-level-3">{{ translations[choice].subtitle ?? '' }}</p>
                </div>
            }
        }
    </div>
</div>
